import Icon from "@/Components/Icon/Icon";
import Spinner from "@/Components/Spinner/Spinner";
import useTable from "@/Components/Tables/useTable";
import useBranch from "@/shared/atoms/useBranch";
import { useSetConfirm } from "@/shared/atoms/useConfirm";
import { useSetModal } from "@/shared/atoms/useModal";
import useId from "@/shared/hooks/useId";
import useRestaurantTableMutation from "@/shared/mutations/restaurantMap/useRestaurantTableMutation";
import useRestaurantTableDelete from "@/shared/mutations/restaurantMap/useRestaurantTableUpdate copy";
import usePrimaryHostnameQuery from "@/shared/queries/hostname/usePrimaryHostnameQeury";
import useWebsiteSettingsQuery from "@/shared/queries/hostname/useWebsiteSettingsQuery";
import { RestaurantTable } from "@/shared/utils/interfaces";
import { generateBranchNameLink } from "@/shared/v2/utils/helpers";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Tooltip from "@/Components/Tooltip/Tooltip";

export interface MapTableProps {
  table: RestaurantTable;
  isActive?: boolean;
  onClick?: () => void;
  onSelect?: () => void;
  editable?: boolean;
  showMapName?: boolean;
}

const MapTable = ({
  editable = true,
  table,
  isActive = false,
  onClick = undefined,
  onSelect = undefined,
  showMapName = false
}: MapTableProps) => {
  const mapId = useId();
  const confirm = useSetConfirm();
  const { data: baseUrl } = usePrimaryHostnameQuery();
  const websiteSettings = useWebsiteSettingsQuery(baseUrl ?? "");
  const [branch] = useBranch();
  const branchPart =
  websiteSettings?.data?.branches?.length === 1 ?
  "" :
  generateBranchNameLink(branch.name);
  const url = `https://${baseUrl}/nl/${branchPart}menu/qr?source=22&tableId=${table.table_number}`;
  const create = useRestaurantTableMutation(mapId);
  const destroy = useRestaurantTableDelete(mapId);
  const ref = useRef<HTMLDivElement>(null);
  const setModal = useSetModal();
  const [t, setTableId] = useTable();
  const { t: tCommon } = useTranslation("");
  const isSelected = t?.item_id === table?.item_id;
  const handleDelete = () => {
    confirm({
      message: tCommon("confirmationMessage"),
      cb: () => {
        destroy.mutate(table);
      }
    });
  };

  const handleDuplicate = () => {
    return create.mutate({ ...table, item_id: undefined });
  };

  useEffect(() => {
    if (isSelected && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [isSelected, ref.current]);

  return (
    <div
      ref={ref}
      onClick={() => {
        setTableId(table);
        onClick && onClick();
      }}
      className="flex cursor-pointer items-center gap-4 px-4 py-6"
      style={{
        backgroundColor: isSelected || isActive ? "var(--grey-blue-light)" : "white",
        borderBottom: "1px solid var(--grey-blue-light)",
      }}
    >
      
      <div className="font-semibold">
        {table.name} - {table.table_number}
      </div>
      <Tooltip content=







      {tCommon("seats")}><div><div className="flex h-8 w-8 items-center justify-center bg-primary text-[white]">
            
        {table.amount_of_seats}
      </div></div></Tooltip>
      {editable &&
      <>
          <div onClick={() => setModal("qrPrint", { table, url })} className="ml-[auto]">
            {websiteSettings.isPending ?
          <Spinner size="0.2rem" /> : <Tooltip content=




          {tCommon("downloadQrCode")}><div><Icon className="h-8 w-8 fill-primary text-primary"
                variants="qr" /></div></Tooltip>

          }
          </div>
          <div onClick={() => setModal("table", { table, mapId })}>
            <Tooltip content=


          {tCommon("editTable")}><div><Icon className="h-8 w-8 fill-primary text-primary"
                variants="edit" /></div></Tooltip>
          
          </div>
          {/* <div
           onClick={(e) => {
             e.stopPropagation();
             handleDuplicate();
           }}
          >
           <Icon
             className="h-8 w-8 fill-primary"
             variants="copy"
           />
          </div> */}
          <div onClick={handleDelete}>
            <Tooltip content=


          {tCommon("deleteTable")}><div><Icon className="h-6 w-6 fill-primary text-primary"
                variants="trash" /></div></Tooltip>
          
          </div>
        </>
      }
      {/* <div ml="auto" onClick={() => setModal("tableOrders", { table })}>
         <Icon
           className="h-8 w-8 fill-primary"
           variants="listCheck"
         />
        </div> */}
      {onSelect &&
      <div className="ml-[auto]">
          <Tooltip content=


        {tCommon("selectTable")}><div><Icon className="h-8 w-8 fill-primary text-primary"
              variants="arrowRight" /></div></Tooltip>
        
        </div>
      }
    </div>);

};

export default MapTable;